import * as Yup from "yup";

const TournamentSchema = Yup.object().shape({
  id: Yup.string().trim().required("Required"),
  name: Yup.string().trim().required("Required"),
  eventTypeId: Yup.mixed().required("Required"),
  displayOrder: Yup.string().required("Required"),
});

export default TournamentSchema;
